import { render, staticRenderFns } from "./RequestTypeCard.vue?vue&type=template&id=5ee8247a&scoped=true"
import script from "./RequestTypeCard.vue?vue&type=script&lang=js"
export * from "./RequestTypeCard.vue?vue&type=script&lang=js"
import style0 from "./RequestTypeCard.vue?vue&type=style&index=0&id=5ee8247a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee8247a",
  null
  
)

export default component.exports